import axios from "axios";
import React, { useEffect, useState, useMemo } from "react";
import { Box, TextField, MenuItem, Typography, CircularProgress, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import AgregarModuloModal from "./Modulos/AgregarModuloModal";
import AgregarGrupoModal from "./Grupos/AgregarGrupoModal";
import EditarModuloModal from './Modulos/EditarModuloModal'
import EditIcon from '@mui/icons-material/Edit';
import EditarGrupoModal from "./Grupos/EditarGrupoModal";
import ModalSemestres from "./modalSemestre";
import EditarSemestreModal from "./EditarSemestreModal";
import { useAlerta } from "utils/alertas";
import SchoolIcon from "@mui/icons-material/School";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";
import ModalGestiones from "layouts/gestiones/componentes/ModalGestiones";

export default function ModulosGrupos() {
  const [modulos, setModulos] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [openGestion, setOpenGestion] = useState(false);
  const [modalGestionOpen, setModalGestionOpen] = useState(false);
  const [editGestion, setEditGestion] = useState(null);
  const [moduloSeleccionado, setModuloSeleccionado] = useState("");
  const [grupoSeleccionado, setGrupoSeleccionado] = useState("");
  const [pensums, setPensums] = useState([]);
  const [modalAsignacionOpen, setModalAsignacionOpen] = useState(false);
  const [loadingModulos, setLoadingModulos] = useState(false);
  const [loadingGrupos, setLoadingGrupos] = useState(false);
  const [pensumSeleccionado, setPensumSeleccionado] = useState("")
  const [modalModuloOpen, setModalModuloOpen] = useState(false);
  const [modalEditarGrupoOpen, setModalEditarGrupoOpen] = useState(false);
  const [modalGrupoOpen, setModalGrupoOpen] = useState(false);
  const [modalEditarOpen, setModalEditarOpen] = useState(false);
  const [moduloAEditar, setModuloAEditar] = useState(null);
  const [grupoAEditar, setGrupoAEditar] = useState(null);
  const [semestre, setSemestre] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);
  const [materiaSeleccionada, setMateriaSeleccionada] = useState("");
  const [asignacion, setAsignacion] = useState({
    grupo_id: "",
    materia_id: "",
    docente_id: "",
    tipo: ""
  });
  const [docentes, setDocentes] = useState([]);
  const [semestresFiltrados, setSemestresFiltrados] = useState([]);
  const [gestiones, setGestiones] = useState([]);
  const [loadingGestiones, setLoadingGestiones] = useState(false);  
  const [gestionSeleccionada, setGestionSeleccionada] = useState("");
  const [gestionAEditar, setGestionAEditar] = useState(null);
  const [semestreSeleccionado, setSemestreSeleccionado] = useState("");
  const [openModalSemestre, setOpenModalSemestre] = useState(false);
  const [modalEditarSemestreOpen, setModalEditarSemestreOpen] = useState(false);
  const [semestreAEditar, setSemestreAEditar] = useState(null);
  const [asignacionesActuales, setAsignacionesActuales] = useState([]);
  const [moduloNombre, setModuloNombre] = useState("");
  const { mostrarAlerta } = useAlerta();

  const abrirModalAsignacion = () => {

  if (!grupoSeleccionado || !semestreSeleccionado) {
    mostrarAlerta("Selecciona grupo y módulo primero", "error");
    return;
  }

  const semestreObj = semestresFiltrados.find(
    s => String(s.id) === String(semestreSeleccionado)
  );


  if (!semestreObj) {
    mostrarAlerta("No se encontró el semestre", "error");
    return;
  }

  const materiaId = semestreObj.materia_id;

  // 🚨 VALIDACIÓN CLAVE
  if (!materiaId) {
    console.error("❌ materia_id viene vacío:", semestreObj);
    mostrarAlerta("El semestre no tiene materia_id", "error");
    return;
  }


  const existentes = asignaciones.filter(
    a => String(a.materia_id) === String(materiaId)
  );

  setModuloNombre(semestreObj.nombre || "");
  setAsignacionesActuales(existentes);

  const nuevaAsignacion = {
    grupo_id: grupoSeleccionado,
    materia_id: materiaId,
    docente_id: "",
    tipo: "capacitacion"
  };


  setAsignacion(nuevaAsignacion);

  fetchDocentes();
  setModalAsignacionOpen(true);
};
  const handleCloseGestion = () => {
    setOpenGestion(false);
    setGestionAEditar(null);
  };
  const cargarGestiones = async () => {
    setLoadingGestiones(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/gestiones`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      const lista = Array.isArray(data.data) ? data.data : data;

      setGestiones(lista || []);
    } catch (error) {
      console.error("Error cargando gestiones:", error);
      setGestiones([]);
    } finally {
      setLoadingGestiones(false);
    }
  };
  const handleDelete = async (gestion) => {
    const confirm = window.confirm(`Eliminar gestión ${gestion.nombre}?`);

    if (!confirm) return;

    try {
        await axios.delete(`/gestiones/${gestion.id}`);
        fetchGestiones();
    } catch (error) {
        console.error(error);
    }
  };
  
  const cargarAsignaciones = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/asignacion`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      });

      const data = await res.json();
      setAsignaciones(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    cargarAsignaciones();
  }, []);
  const handleSaveGestion = async (data) => {
    try {
      const formData = new FormData();

      formData.append("nombre", data.nombre);
      formData.append("fecha_inicio", data.fecha_inicio || "");
      formData.append("fecha_fin", data.fecha_fin || "");

      if (data.id) {
        formData.append("_method", "PUT");

        await axios.post(`/gestiones/${data.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        mostrarAlerta("Gestión editada correctamente", "success");
      } else {
        await axios.post("/gestiones", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        mostrarAlerta("Gestión creada correctamente","success");
      }

      handleCloseGestion();

      // vuelve a cargar el select de gestiones
      cargarGestiones();

    } catch (error) {
      console.error(error);
      mostrarAlerta(error.message || "Ocurrió un error al guardar la gestión", "error");
    }
  };

  const handleSaveAsignacion = async () => {
    try {

      const response = await fetch(`${process.env.REACT_APP_API_URL}/docente/asignacion`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(asignacion)
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Error al asignar docente");
      }
      console.log(asignacion);

      cargarAsignaciones();
      setModalAsignacionOpen(false);
      setAsignacion({
        grupo_id: "",
        materia_id: "",
        docente_id: "",
        tipo: ""
      });
      mostrarAlerta("Docente asignado a grupo correctamente","success");

    } catch (error) {
      console.error(error);
      mostrarAlerta(error.message || "Ocurrió un error al asignar docente a grupo","error");
    }
  };

  const fetchDocentes = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/docente`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        }
      });

      const data = await res.json();
      setDocentes(data);

    } catch (error) {
      console.error(error);
    }
  };

  const token = sessionStorage.getItem("access_token");

  const handleOpenSemestre = (capacitacion) => {
    setModuloSeleccionado(capacitacion);
    setOpenModalSemestre(true);
  };
  const handleCloseSemestre = () => {
    setOpenModalSemestre(false);
    setCarreraSeleccionada(null);
  };
  const handleSemestreChange = (event) => {
    const gestionId = event.target.value;

    setGestionSeleccionada(gestionId);
    //setSemestreSeleccionado(gestionId);
    cargarGruposSemestre(gestionId,moduloSeleccionado);
  };

  useEffect(() => {
    cargarModulos();
    cargarGestiones();
  }, [token]);
  const cargarSemestres = (tipo, programa_id) => {

    fetch(`${process.env.REACT_APP_API_URL}/semestre/${tipo}/${programa_id}`,{
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
    .then((res) => res.json())
    .then((data)=> {
      const lista = Array.isArray(data.data) ? data.data : data;
      setSemestresFiltrados(lista || []);
    })
    .catch((err)=>{
      console.error(err);
      setSemestresFiltrados([]);
    });
  }

  const cargarGruposSemestre = (gestionId,capacitacionId) => {
    setLoadingGrupos(true);
    fetch(`${process.env.REACT_APP_API_URL}/grupos/${gestionId}/${capacitacionId}`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        const lista = Array.isArray(data.data) ? data.data : data;
        setGrupos(lista || []);
        setLoadingGrupos(false);
      })
      .catch((err) => {
        console.error(err);
        setGrupos([]);
        setLoadingGrupos(false);
      });
  };
  useEffect(() => {
    cargarModulos();
  }, [token]);

  const handleEliminarGrupo = async () => {
    if ( !grupoSeleccionado) {
      mostrarAlerta("Primero selecciona un grupo para eliminar.","error")
      return;
    }

    // Confirmación antes de eliminar
    const confirmDelete = window.confirm("¿Estás seguro de eliminar este grupo?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/modulos/grupo/${grupoSeleccionado}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Error al eliminar grupo");

      mostrarAlerta("Grupo eliminado correctamente","success")

      // 🔹 Refrescar la lista de grupos y limpiar selección
      cargarGrupos(grupoSeleccionado);
      setGrupoSeleccionado("");
    } catch (error) {
      console.error("Error al eliminar grupo:", error);
      alert(error.message);
    }
  };

  const handleEliminarCapacitacion = async () => {
    if ( !moduloSeleccionado) {
      alert("Primero selecciona una capacitacion para eliminar.");
      return;
    }

    // Confirmación antes de eliminar
    const confirmDelete = window.confirm("¿Estás seguro de eliminar esta capacitacion?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/modulos/${moduloSeleccionado}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Error al eliminar capacitacion");

      mostrarAlerta("Capacitacion eliminada correctamente","success")
      window.location.reload();
      // 🔹 Refrescar la lista de grupos y limpiar selección
      setGrupoSeleccionado("");
    } catch (error) {
      console.error("Error al eliminar grupo:", error);
      alert(error.message);
    }
  };
  const handleEliminarModulo = async () => {
    if ( !semestreSeleccionado) {
      alert("Primero seleccione un modulo para eliminar.");
      return;
    }

    // Confirmación antes de eliminar
    const confirmDelete = window.confirm("¿Estás seguro de eliminar este modulo?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/semestres/eliminar/${semestreSeleccionado}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Error al eliminar capacitacion");

      alert("Modulo eliminado correctamente");
      window.location.reload();
      // 🔹 Refrescar la lista de grupos y limpiar selección
      setSemestre("");
    } catch (error) {
      console.error("Error al eliminar grupo:", error);
      alert(error.message);
    }
  };

  const handleEditarModulo = (modulo) => {
    setModuloAEditar(modulo); // guardamos objeto completo
    setModalEditarOpen(true);  // abrimos modal
  };

  const cargarModulos = () => {
    setLoadingModulos(true);
    fetch(`${process.env.REACT_APP_API_URL}/modulos`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        // Si el backend devuelve un array directo o dentro de data.data
        const lista = Array.isArray(data.data) ? data.data : data;
        setModulos(lista || []);
        setLoadingModulos(false);
      })
      .catch((err) => {
        console.error(err);
        setModulos([]); // evita undefined
        setLoadingModulos(false);
      });
  };
  const asignacionesRows = useMemo(() => {
    return asignacionesActuales.map(item => ({
      grupo: grupos.find(g => g.id == item.grupo_id)?.nombre || "",
      modulo: moduloNombre,
      docente: docentes.find(d => d.id == item.docente_id)?.name || "",
      accion: (
        <MDButton
          color="error"
          size="small"
          onClick={() => eliminarAsignacion(item.id)}
        >
          Eliminar
        </MDButton>
      )
    }));
  }, [asignacionesActuales, grupos, docentes, moduloNombre]);

  const eliminarAsignacion = async (id) => {
    try {

      await fetch(`${process.env.REACT_APP_API_URL}/asignacion/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const nuevas = asignacionesActuales.filter(a => a.id !== id);
      setAsignacionesActuales(nuevas);

      mostrarAlerta("Asignación eliminada", "success");

    } catch (error) {
      mostrarAlerta("Error al eliminar", "error");
    }
  };

  const handleModuloChange = (event) => {
    const moduloId = event.target.value;
    setModuloSeleccionado(moduloId);
    cargarSemestres("capacitacion",moduloId);
    setGrupoSeleccionado("");
    setGrupos([]);

    // Filtramos localmente los pensums que pertenecen a esta capacitación_id
    const filtrados = pensums.filter(p => String(p.capacitacion_id) === String(moduloId));
  };
  const handlePensumChange = (event) => {
    const pensumId = event.target.value;
    setGrupoSeleccionado("");
    setGrupos([]);

    if (pensumId) {
      cargarGruposPorPensum(pensumId);
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" mb={3}>
        Seleccionar Capacitacion y Grupo
      </Typography>
      <Box sx={{
        display: "flex",
        flexWrap: "wrap", // 🔥 CLAVE
        gap: 2,
        alignItems: "center",
      }}>
        
        {/* 🏫 1. SELECT CAPACITACIÓN */}
        {loadingModulos ? (
          <CircularProgress size={24} />
        ) : (
          <Box sx={{
            flex: 1,
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // 🔥 magia
            gap: 1,
            alignItems: { xs: "stretch", md: "center" },
          }}>
            <TextField
              select
              fullWidth
              label="Capacitación"
              value={moduloSeleccionado}
              onChange={handleModuloChange}
              InputLabelProps={{ shrink: true }}
              SelectProps={{ native: true }}
            >
              <option value=""></option>
              {modulos.map((modulo) => (
                <option key={modulo.id} value={modulo.id}>
                  {modulo.nombre}
                </option>
              ))}
            </TextField>
            <Box
              sx={{
                display: "flex",
                gap: 0.5,
                flexWrap: { xs: "wrap", md: "nowrap" }, // 🔥 clave
                flexDirection: { xs: "row", md: "row" }, // siempre fila
                justifyContent: { xs: "flex-start", md: "center" },
              }}
            >
              <Tooltip title="Agregar módulo">
                <IconButton color="primary" onClick={() => setModalModuloOpen(true)}>
                  <AddIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Editar módulo">
                <span>
                  <IconButton
                    color="secondary"
                    disabled={!moduloSeleccionado}
                    onClick={() => {
                      setModuloAEditar(moduloSeleccionado);
                      setModalEditarOpen(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </span>
              </Tooltip>
              
              <Tooltip title="Eliminar capacitación">
                <span>
                  <IconButton color="error" disabled={!moduloSeleccionado} onClick={handleEliminarCapacitacion}>
                    <DeleteIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
            <TextField
              select
              fullWidth
              label="Gestión"
              value={gestionSeleccionada}
              onChange={handleSemestreChange}
              InputLabelProps={{ shrink: true }}
              SelectProps={{ native: true }}
            >
              <option value=""></option>
              {gestiones.map((gestion) => (
                <option key={gestion.id} value={gestion.id}>
                  {gestion.nombre}
                </option>
              ))}
            </TextField>
            <Box
              sx={{
                display: "flex",
                gap: 0.5,
                flexWrap: { xs: "wrap", md: "nowrap" }, // 🔥 clave
                flexDirection: { xs: "row", md: "row" }, // siempre fila
                justifyContent: { xs: "flex-start", md: "center" },
              }}
            >
              <Tooltip title="Nueva gestión">
                <IconButton
                  color="primary"
                  onClick={() => {
                    setEditGestion(null);
                    setOpenGestion(true);
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Editar gestión">
                <span>
                  <IconButton
                    color="secondary"
                    disabled={!gestionSeleccionada}
                    onClick={() => {
                      const gestion = gestiones.find(
                        (g) => String(g.id) === String(gestionSeleccionada)
                      );

                      setEditGestion(gestion);
                      setOpenGestion(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title="Eliminar gestión">
                <span>
                  <IconButton
                    color="error"
                    disabled={!gestionSeleccionada}
                    onClick={async () => {
                      const gestion = gestiones.find(
                        (g) => String(g.id) === String(gestionSeleccionada)
                      );

                      if (!gestion) return;

                      const confirm = window.confirm(
                        `¿Eliminar la gestión ${gestion.nombre}?`
                      );

                      if (!confirm) return;

                      try {
                        await axios.delete(`/gestionEliminar/${gestion.id}`);
                        cargarGestiones();

                        setGestionSeleccionada("");
                        setGrupos([]);
                        mostrarAlerta("Gestión eliminada correctamente","success");
                      } catch (error) {
                        console.error(error);
                      }
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
          </Box>
        )}
        
      </Box>

      {/* Selección de grupo */}
      {loadingGrupos ? (
        <CircularProgress size={24} />
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt:4 }}>
          <TextField
            select
            fullWidth
            label="Grupo"
            value={grupoSeleccionado}
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setGrupoSeleccionado(e.target.value)}
          >
            <option value=""></option>
            {grupos.length > 0 ? (
              grupos.map((grupo) => (
                <option key={grupo.id} value={grupo.id}>
                  {grupo.nombre} ({grupo.turno})
                </option>
              ))
            ) : (
              <option value="" disabled>
                No hay grupos
              </option>
            )}
          </TextField>
          <Tooltip title="Agregar grupo">
            <IconButton
              color="primary"
              onClick={() => {
                if (!moduloSeleccionado) return mostrarAlerta("Selecciona un módulo primero","success");
                setModalGrupoOpen(true);
              }}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar grupo">
            <span>
              <IconButton
                color="secondary"
                disabled={!grupoSeleccionado}
                onClick={() => {
                  setGrupoAEditar(grupoSeleccionado);
                  setModalEditarGrupoOpen(true);
                }}
              >
                <EditIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Eliminar grupo">
            <span>
              <IconButton
                color="error"
                disabled={!grupoSeleccionado}
                onClick={handleEliminarGrupo}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      )}

      {/* Modal módulo */}
      <AgregarModuloModal
        open={modalModuloOpen}
        onClose={() => setModalModuloOpen(false)}
        onModuloAgregado={cargarModulos}
      />

      {/* Modal grupo */}
      <AgregarGrupoModal
        open={modalGrupoOpen}
        onClose={() => setModalGrupoOpen(false)}
        onGrupoAgregado={() => cargarGruposSemestre(gestionSeleccionada, moduloSeleccionado)}
        moduloId={moduloSeleccionado}
        gestionId={gestionSeleccionada}
      />
      <ModalGestiones
        open={openGestion}
        onClose={handleCloseGestion}
        onSave={handleSaveGestion}
        initialData={editGestion}
      />
      <EditarModuloModal
        open={modalEditarOpen}
        onClose={() => setModalEditarOpen(false)}
        moduloId={moduloAEditar}  // 👈 pasamos solo el id
        onModuloActualizado={cargarModulos}
      />   
      <EditarGrupoModal
        open={modalEditarGrupoOpen}
        onClose={() => setModalEditarGrupoOpen(false)}
        grupoId={grupoSeleccionado}
        onGrupoActualizado={() => cargarGruposSemestre(gestionSeleccionada, moduloSeleccionado)}
        tipo = {"capacitacion"}
        capacitacion_id = {moduloSeleccionado}
      />
      <ModalSemestres
        open={openModalSemestre}
        onClose={() => setOpenModalSemestre(false)}
        capacitacion_id={moduloSeleccionado}
        onSemestreCreado={() => {
          cargarSemestres("capacitacion", moduloSeleccionado);
          setGestionSeleccionado(""); // 🔥 limpia selección
          setGrupos([]); // 🔥 opcional limpiar grupos
        }}
      />
      <EditarSemestreModal
        open={modalEditarSemestreOpen}
        onClose={() => setModalEditarSemestreOpen(false)}
        semestreId={semestreAEditar}
        onActualizado={() => {
          cargarSemestres("capacitacion", moduloSeleccionado);
        }}
      />
      {modalAsignacionOpen && (
        <Box
          sx={{
            position: "fixed",
            inset: 0, // 👈 reemplaza top/left/width/height
            bgcolor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            p: 2, // 👈 espacio en móviles (IMPORTANTE)
            overflow: "auto" // 👈 evita que se corte en pantallas pequeñas
          }}
        >
          <Box
            sx={{
              bgcolor: "#fff",
              p: 3,
              borderRadius: 2,
              width: {
                xs: "100%",   // 👈 celular
                sm: 500,      // 👈 tablet
                md: 800       // 👈 desktop (tu valor actual)
              },
              maxHeight: "90vh",
              overflow: "auto"
            }}
          >

            <Typography variant="h6" mb={2}>
              Asignaciones de: {moduloNombre}
            </Typography>

            <DataTable
              table={{
                columns: [
                  { Header: "Grupo", accessor: "grupo" },
                  { Header: "Módulo", accessor: "modulo" },
                  { Header: "Docente", accessor: "docente" },
                  { Header: "Acción", accessor: "accion" }
                ],
                rows: asignacionesRows
              }}
            />

            <TextField
              select
              fullWidth
              label="Grupo"
              value={asignacion.grupo_id}
              SelectProps={{ native:true }}
              disabled
              onChange={(e)=>
                setAsignacion({...asignacion, grupo_id:e.target.value})
              }
              margin="normal"
            >
              <option value="">Seleccione</option>
              {grupos.map(g=>(
                <option key={g.id} value={g.id}>
                  {g.nombre}
                </option>
              ))}
            </TextField>

            <TextField
              select
              fullWidth
              label="Docente"
              value={asignacion.docente_id}
              SelectProps={{ native:true }}
              onChange={(e)=>
                setAsignacion({...asignacion, docente_id:e.target.value})
              }
              margin="normal"
            >
              <option value=""></option>
              {docentes.map(d=>(
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </TextField>

            {/* BOTONES */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>

              <MDButton onClick={() => setModalAsignacionOpen(false)}>
                Cancelar
              </MDButton>

              <MDButton
                variant="contained"
                color="info"
                onClick={handleSaveAsignacion}
                sx={{ color: "#fff" }}
              >
                Guardar
              </MDButton>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}
